import { useIntl } from "react-intl";
import { useMemo } from "react";
import { Condition } from "../../api/decimal/methods/product.ts";

export default function useConditionMap(): Record<Condition, string> {
  const intl = useIntl();

  return useMemo(
    () => ({
      new: intl.formatMessage({ defaultMessage: "New" }),
      used: intl.formatMessage({ defaultMessage: "Used" }),
      marketplace: intl.formatMessage({ defaultMessage: "Marketplace" }),
    }),
    [intl]
  );
}
